import React from 'react';
import "./ThankYou.css";
import { Col, Container, Row } from 'react-bootstrap';

export default function ThankYou() {
  return (
    <>
        <Container>
            <Row>
                <Col>
                    <div className='thankyou-page'>
                        <div className="thanks-titile" id="thanks-header">
                            <h1 className="thanks-titile-head" data-lead-id="site-header-title">THANK YOU!</h1>
                        </div>
                        <div className="main-content">
                            <i className="fa fa-check main-content__checkmark" id="checkmark"></i>
                            <p className="thanks-content" data-lead-id="main-content-body">Thank you! Your application was successfully submitted.</p>
                        </div> 
                        <div className="thanks-footer" id="footer">
                            <p className="site-footer__fineprint" id="fineprint">Copyright ©2023 | All Rights Reserved</p>
                        </div>
                    </div>
                </Col>
            </Row>
        </Container>
    </>
  )
}
